export const LOCAL_STORAGE_PREFIX = 'viax-';

// History keys
export const ORGANIZAIONS_HISTORY_KEY = 'organizations';
export const PERSONS_HISTORY_KEY = 'persons';
export const PERSONE_USER = 'User';

/**
 * format of date string
 *
 * @type {string}
 */
export const FORMAT_OF_DATE = 'MM/dd/yyyy';
export const FORMAT_OF_DATE_FOR_SAVE = 'yyyy-MM-dd';
export const FORMAT_OF_DATE_EXTENDED = 'MMM dd, yyyy';
export const FORMAT_OF_DATE_EXTENDED_TIME = 'MMM dd, yyyy h:mm a';
export const FORMAT_OF_DATE_EXTENDED_TIME_FOR_SERVER = "yyyy-MM-dd'T'HH:mm:ss'Z'";
export const FORMAT_OF_DATE_SECOND = 'dd MMM yyyy';
export const FORMAT_OF_DATE_THIRD = 'MM/dd/yyyy h:mm a';
export const FORMAT_OF_TIME = 'h:mm a';

export const MASK_OF_PHONE_NUMBER = '(###) ###-####';
export const MASK_OF_PHONE_NUMBER_IL = '(#) ###-###-###';
export const MASK_OF_ZIP_CODE_DEFAULT = '#####-####';
export const MASK_OF_ZIP_CODE_US = '#####-####';
export const MASK_OF_ZIP_CODE_CA = 'A#A #A#';
export const MASK_OF_ZIP_CODE_IL = '#######';

/**
 * Statuses of order contracts
 *
 * @type {Object}
 */
export const ORDERS_STATUSES = {
  active: 'ACTIVE',
};

export const CANCELLED_STATUS = 'CANCELLED';
/**
 * Countries
 */
export const countries = {
  US: {
    name: 'United States',
    nameOfProvinces: 'State',
    placeholderForProvinces: 'Enter state',
    zipCodeMask: MASK_OF_ZIP_CODE_US,
    phoneMask: MASK_OF_PHONE_NUMBER,
  },

  CA: {
    name: 'Canada',
    nameOfProvinces: 'Province',
    placeholderForProvinces: 'Enter province',
    zipCodeMask: MASK_OF_ZIP_CODE_CA,
    phoneMask: MASK_OF_PHONE_NUMBER,
  },

  IL: {
    name: 'Israel',
    nameOfProvinces: 'District',
    placeholderForProvinces: 'Enter disctrict',
    zipCodeMask: MASK_OF_ZIP_CODE_IL,
    phoneMask: MASK_OF_PHONE_NUMBER_IL,
  },
};

/**
 * Commissions defaults
 *
 * @type String | {Object}
 */
export const DEFAULT_COMMISSION_PLAN = 'FOLLOW_BILLING_PLAN';
export const DEFAULT_COMMISSION_PAYABLE = 'INVOICE_PAYMENT';
export const DEFAULT_COMMISSION_TYPES = {
  PRODUCT_BASED: 'PRODUCT_BASED',
  FIXED: 'FIXED',
};

/**
 * Types of errors during invoice creation
 *
 * @type {Object}
 */
export const INVOICE_ERROR_TYPES = {
  BILLING_LINES: 'BILLING_LINES',
};

export const SEARCH_TYPES = {
  ORDERS: 'ORDERS',
  ORGANIZATIONS: 'ORGANIZATIONS',
  POLICY: 'POLICY',
  PRICING_MODELS: 'PRICING_MODELS',
  PRODUCTS: 'PRODUCTS',
  PRODUCT_CONFIGURATIONS: 'PRODUCT_CONFIGURATIONS',
  TICKETS: 'TICKETS',
  V_TICKETS: 'V_TICKETS',
  TYPES: 'TYPES',
  CONTACTS: 'CONTACTS',
  WORKFLOWS: 'WORKFLOWS',
  ATTRIBUTES: 'ATTRIBUTES',
  ROLES: 'ROLES',
  EMAIL_LOGS: 'EMAIL_LOGS',
  PAYMENTS_LOG: 'PAYMENTS_LOG',
  EQUIPMENT_RECORDS: 'EQUIPMENT_RECORDS',
  INVOICE_BATCHES: 'INVOICE_BATCHES',
  PROJECTS: 'PROJECTS',
  PAYMENT_PORTAL_INVOICES: 'PAYMENT_PORTAL_INVOICES',
  INVOICE_TAX_LOG: 'INVOICE_TAX_LOG',
  ADV_SEARCH_MCR: 'ADV_SEARCH_MCR',
  ADV_SEARCH_COMMISSIONS: 'ADV_SEARCH_COMMISSIONS',
};

export const COMMISSIONS_ADV_SEARCH_TYPES = {
  COMMISSIONS: 'COMMISSIONS',
};

// Breakpoints
export const HEADER_BREAK_POINT_MOBILE = 740;
export const TABLET_MEDIA_BREAKPOINT = 768;
export const DESKTOP_MEDIA_BREAKPOINT = 1024;

// Message bus possible subjects
export const MESSAGE_BUS = {
  UPDATE_POLICY_SETS: 'UPDATE_POLICY_SETS',
};

// Product configuration items
export const CONFIG_ITEMS = {
  SEGMENT: 'SEGMENT',
  COMPONENT: 'COMPONENT',
  OPTION: 'OPTION',
};

export const USER_LOGIN_CONFIG_LABELS = {
  ENABLE: 'Yes',
  DISABLE: 'No',
};

export const PERSON_STATUSES = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const PERSON_STATUS_CONFIG_LABELS = {
  [PERSON_STATUSES.ACTIVE]: 'Yes',
  [PERSON_STATUSES.INACTIVE]: 'No',
};

export const AUTO_ASSIGNMENT_CONFIG = {
  ALLOW: 'ALLOW',
  DENY: 'DENY',
};

export const AUTO_ASSIGNMENT_CONFIG_LABELS = {
  [AUTO_ASSIGNMENT_CONFIG.ALLOW]: 'Yes',
  [AUTO_ASSIGNMENT_CONFIG.DENY]: 'No',
};

export const ALLOWED_STATUSES_FOR_DELETE_SC = ['CANCELLED', 'INITIAL_DRAFT', 'PENDING_ORDER', 'PROVISIONING', 'ENGINEERING'];

export const BILLING_PLANS_LABELS_MAP = {
  MONTHLY_ADVANCE_1: '1M',
  MONTHLY_ADVANCE_15: '15M',
  YEARLY_CUSTOM_SPLIT_CURRENT_PERIOD_1: '1Y',
  YEARLY_CUSTOM_SPLIT_CURRENT_PERIOD_15: '15Y',
};

export const DATE_RADIO_INDICATOR = {
  AM: 'AM',
  PM: 'PM',
};

// Payment steps
export const CHOOSE_PAYMENT_METHOD = 'CHOOSE_PAYMENT_METHOD';
export const CREATE_PAYMENT_METHOD = 'CREATE_PAYMENT_METHOD';
export const CONFIRM_PAYMENT = 'CONFIRM_PAYMENT';
export const FINALIZE_PAYMENT = 'FINALIZE_PAYMENT';
export const CHOOSE_SUBSCRIPTION_METHOD = 'CHOOSE_SUBSCRIPTION_METHOD';
export const CREATE_SUBSCRIPTION_METHOD = 'CREATE_SUBSCRIPTION_METHOD';
export const CONFIRM_SUBSCRIPTION = 'CONFIRM_SUBSCRIPTION';
